(function () {
  function setNavOpen(root, button, panel, isOpen) {
    root.classList.toggle('is-nav-open', isOpen);
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    button.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    if (isOpen) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function setSearchOpen(root, button, panel, isOpen) {
    root.classList.toggle('is-search-open', isOpen);
    if (button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    if (isOpen) {
      panel.removeAttribute('hidden');
      // Ensure Flex overlay never stays open alongside inline search
      if (window.PXUTheme && window.PXUTheme.predictiveSearch && typeof window.PXUTheme.predictiveSearch.hideMobileSearch === 'function') {
        try {
          window.PXUTheme.predictiveSearch.hideMobileSearch();
        } catch (err) {}
      }
      var flexMobile = document.querySelector('.mobile-search');
      if (flexMobile) {
        flexMobile.style.display = 'none';
      }
      var input = panel.querySelector('[data-repolished-mobile-search-input]');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 10);
      }
    } else {
      panel.setAttribute('hidden', '');
      var results = panel.querySelector('.search__results-wrapper');
      if (results) {
        results.style.display = 'none';
        results.innerHTML = '';
      }
    }
  }

  function bindSubmenus(root) {
    root.querySelectorAll('[data-repolished-mobile-submenu-toggle]').forEach(function (toggle) {
      if (toggle.dataset.bound === 'true') return;
      toggle.dataset.bound = 'true';

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var item = toggle.closest('.repolished-mobile-nav__item');
        if (!item) return;
        var submenu = item.querySelector('[data-repolished-mobile-submenu]');
        if (!submenu) return;

        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          submenu.setAttribute('hidden', '');
        } else {
          submenu.removeAttribute('hidden');
        }
      });
    });
  }

  function bind(root) {
    if (!root || root.dataset.repolishedMobileNavReady === 'true') return;
    root.dataset.repolishedMobileNavReady = 'true';

    var menuButton = root.querySelector('[data-repolished-mobile-menu-toggle]');
    var menuPanel = root.querySelector('.repolished-mobile-nav-wrap');
    var searchButton = root.querySelector('[data-repolished-mobile-search-toggle]');
    var searchPanel = root.querySelector('[data-repolished-mobile-search]');

    if (menuButton && menuPanel) {
      setNavOpen(root, menuButton, menuPanel, false);
      bindSubmenus(root);

      menuButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = menuButton.getAttribute('aria-expanded') === 'true';
        if (!open && searchButton && searchPanel) {
          setSearchOpen(root, searchButton, searchPanel, false);
        }
        setNavOpen(root, menuButton, menuPanel, !open);
      });
    }

    if (searchButton && searchPanel) {
      setSearchOpen(root, searchButton, searchPanel, false);

      searchButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = searchButton.getAttribute('aria-expanded') === 'true';
        if (!open && menuButton && menuPanel) {
          setNavOpen(root, menuButton, menuPanel, false);
        }
        setSearchOpen(root, searchButton, searchPanel, !open);
      });
    }

    document.addEventListener('click', function (event) {
      if (root.classList.contains('is-nav-open') && menuButton && menuPanel && !root.contains(event.target)) {
        setNavOpen(root, menuButton, menuPanel, false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (root.classList.contains('is-nav-open') && menuButton && menuPanel) {
        setNavOpen(root, menuButton, menuPanel, false);
      }
      if (root.classList.contains('is-search-open') && searchButton && searchPanel) {
        setSearchOpen(root, searchButton, searchPanel, false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.repolished-mobile-header').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('.repolished-mobile-header').forEach(function (root) {
      root.dataset.repolishedMobileNavReady = 'false';
      bind(root);
    });
    if (event.target.classList && event.target.classList.contains('repolished-mobile-header')) {
      event.target.dataset.repolishedMobileNavReady = 'false';
      bind(event.target);
    }
  });
})();
